import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosServices from '@libs/@core/axios';
import API_URL from '@libs/@core/constants/endpointApi';
import { useSnackbarContext } from '@libs/@core/contexts/snackbarContext';
import { QUERY_KEYS } from '@libs/@core/constants/key';
var getPublishTemplateMutation = function (templateId) {
    var response = axiosServices.patch("".concat(API_URL.CASHFLOW_TEMPLATE.DETAIL(templateId)));
    return response;
};
var usePublishTemplateMutate = function () {
    var snackbar = useSnackbarContext();
    var queryClient = useQueryClient();
    var mutate = useMutation({
        mutationFn: function (templateId) { return getPublishTemplateMutation(templateId); },
        onSuccess: function () {
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.CASHFLOW_TEAMPLATE_LIST]
            });
            snackbar.success('Publish template successfully');
        },
        onError: function () {
            snackbar.error('Publish template failed');
        }
    });
    return mutate;
};
export default usePublishTemplateMutate;
